
import 'isomorphic-fetch';

import {SESSION_KEY, loadData} from '../storage/local-storage';

export const METHOD_GET = 'GET';
export const METHOD_POST = 'POST';
export const METHOD_PUT = 'PUT';
export const METHOD_PATCH = 'PATCH';
export const METHOD_DELETE = 'DELETE';

export const API_ROOT = "/api";
export const TYPE_JSON = 'json';
export const TYPE_FORM = 'form';

const configureFetch = (endpoint, actionData, method = METHOD_GET, requireAuth, type) => () => {
    const fullURL = (endpoint.indexOf(API_ROOT) === -1) ? `${API_ROOT}${endpoint}` : endpoint;

    let body;
    if (type === TYPE_FORM) {
        body = actionData.body;
    } else {
        body = typeof actionData === 'string' ? actionData : JSON.stringify(actionData);
    }

    const config = {
        method,
        headers: {
            "Content-Type": "application/json",
            'X-Requested-With': 'XMLHttpRequest'
        }
    };

    if (type === TYPE_FORM) {
        delete config.headers['Content-Type'];
    }

    if (requireAuth) {
        const {access_token: token} = loadData(SESSION_KEY);
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Request with GET/HEAD method cannot have body
    if (method !== METHOD_GET) {
        config.body = body;
    }

    return fetch(fullURL, config).then(res => res.json().then(json => ({json, res}))).then(({json, res}) => {
        if (!res.ok) {
            const {status} = res;
            return Promise.reject(Object.assign({}, {status}, {res: json}));
        }
        return Object.assign({}, json);
    });
};

export const CALL_API = Symbol('Call API');

export default store => next => action => {
    const callAPI = action[CALL_API];
    if (!callAPI) {
        return next(action);
    }

    let {endpoint} = callAPI;
    const {method, types, requireAuth = true, type = TYPE_JSON} = callAPI;

    if (typeof endpoint === 'function') {
        endpoint = endpoint(store.getState());
    }

    if (typeof endpoint !== 'string') {
        throw new Error('Specify a string endpoint URL.');
    }

    if (!Array.isArray(types) || types.length !== 3) {
        throw new Error('Expected an array of three action types');
    }

    if (!types.every(type => typeof type === 'string')) {
        throw new Error('Expected action types to be string');
    }

    function actionWith(data) {
        const finalAction = Object.assign({}, action, data);
        delete finalAction[CALL_API];
        return finalAction;
    }

    const fetchAPI = configureFetch(endpoint, actionWith({}), method, requireAuth, type);
    const [requestType, successType, failureType] = types;

    next(actionWith({type: requestType}));
    return fetchAPI().then(
        res => next(actionWith({res, type: successType})),
        error => next(actionWith({error, type: failureType}))
    );
}


// WEBPACK FOOTER //
// ./resources/assets/js/middleware/api.js